import { render, staticRenderFns } from "./SustTargetsCompletion.vue?vue&type=template&id=376ee780&scoped=true"
import script from "./SustTargetsCompletion.vue?vue&type=script&lang=js"
export * from "./SustTargetsCompletion.vue?vue&type=script&lang=js"
import style0 from "./SustTargetsCompletion.vue?vue&type=style&index=0&id=376ee780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376ee780",
  null
  
)

export default component.exports